import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import InflationTable from "components/property-market/inflation/inflation-table"
import { WithTip } from 'components/tooltip/with-tip'
// Data
import api_match from "data/interface/api"
import importService from "data/import"
import inflationService, { Inflation } from "data/inflation"
import propertyService, { Property } from 'data/property'
import { alphanum } from "components/table/lib/sort"
import { ContextRow } from './inflation-table'
import toggles from "feature-toggles"
//Styles
import { Inflation_s } from "components/property-market/inflation/inflation-styles"
import { AddIcon } from "images/icons/tools"

const tableId = "commercial-inflation-table"

const PMInflation: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<Inflation[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<Property|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    return function cleanup() {
      inflationSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    inflationService.fetchInflation(propertyId)
    propertyService.fetchProperty(propertyId)

  }, [propertyId])

  const Add = () => {
    const defaults = property && property['defaultsnameditem'] || {}
    return (
      <a onClick={() => inflationService.create(propertyService.getStoredPropertyId(), defaults)}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'inflationid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected ? selected : data

  return (
    <Inflation_s>
      <Toolbar>
        <Add />
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
        <ImportIcon />
        <ExportIcon template="inflation" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport && <InflationTable tableId={tableId} data={_data} defaults={{...property['defaultsnameditem']}} selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}} /> }
    </Inflation_s>
  )
}

export default PMInflation
